import React from 'react';
import _ from 'lodash';

function CustomPropertySelect({ propertiesArray }) {
  return (
    <>
      {propertiesArray.length === 1 ? (
        <option key={propertiesArray[0].propertyId} value={propertiesArray[0].propertyId}>
          {propertiesArray[0].propertyName}
        </option>
      ) : (
        <>
          <option key={''} value={''}>
            All Properties
          </option>
          {_.map(propertiesArray, (property, index) => (
            <option key={property.propertyId} value={property.propertyId}>
              {property.propertyName}
            </option>
          ))}
        </>
      )}
    </>
  );
}

export default CustomPropertySelect;
